"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = _interopRequireDefault(require("./form"));

var _schemaResolver = _interopRequireDefault(require("./../helpers/schema-resolver"));

var _fieldOptionsHelper = _interopRequireDefault(require("./../helpers/field-options-helper"));

var _propertyEditorInternalContext = _interopRequireDefault(require("./../contexts/property-editor-internal-context"));

var _propertyEditorContext = _interopRequireDefault(require("./../contexts/property-editor-context"));

var _validate = _interopRequireDefault(require("./../validate"));

var _get = _interopRequireDefault(require("lodash/get"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

require("../style/property-editor.scss");

require("./lang");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _each = _interopRequireDefault(require("lodash/each"));

var _remove = _interopRequireDefault(require("lodash/remove"));

var _transformValues = require("./../helpers/transform-values");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var PropertyEditor = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PropertyEditor, _Component);

  var _super = _createSuper(PropertyEditor);

  function PropertyEditor(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PropertyEditor);
    _this = _super.call(this, props, context); // not defined in the state, because it should not trigger a "rerender" if its set

    _this.loadFieldOptions = function () {
      var _loop = function _loop(key) {
        var fieldOptions = _this.state.fieldOptions[key];

        if (!(0, _isEmpty["default"])(fieldOptions.url) && (0, _isEmpty["default"])(fieldOptions.options)) {
          // options needs to be loaded, they are not loaded yet.
          if (_this.fieldOptionsResolvers[key] && _this.fieldOptionsResolvers[key].url === fieldOptions.url) {
            // some request is still pending, dont start a new promise
            return "continue";
          } else {
            // check if the url has changed. we might want to abort the old request
            if (_this.fieldOptionsResolvers[key] && _this.fieldOptionsResolvers[key].url !== fieldOptions.url) {} // todo implement AbortController, only use it on componentDidUnMount
            // create loading promise


            var promise = _fieldOptionsHelper["default"].getOptions(fieldOptions.url, _this.state.fields.find(function (field) {
              return field.fieldId === key;
            }), _this.props.api, false, _this.context.useApiGateway);

            _this.fieldOptionsResolvers[key] = {
              url: fieldOptions.url,
              promise: promise
            };
            promise.then(function (options) {
              if (_this.mounted) {
                var _fieldOptions = (0, _cloneDeep["default"])(_this.state.fieldOptions);

                _fieldOptions[key].options = options;
                _this.fieldOptionsResolvers[key].promise = undefined;
                _this.props.onFieldOptionsLoaded && _this.props.onFieldOptionsLoaded(key, options);

                _this.setState({
                  fieldOptions: _fieldOptions
                });
              }
            });
          }
        }
      };

      // lazy load the options
      for (var key in _this.state.fieldOptions) {
        var _ret = _loop(key);

        if (_ret === "continue") continue;
      }
    };

    _this.getCurrentValues = function () {
      if (_this.state.isControlled) {
        throw Error('You can got get the values from a controlled PropertyEditor. You own the values, not the PropertyEditor');
      }

      return (0, _cloneDeep["default"])(_this.state.values);
    };

    _this.isDirty = function () {
      return _this.state.isDirty;
    };

    _this.makeClean = function () {
      _this.setState({
        isDirty: false
      });
    };

    _this.validate = function () {
      return _this.runValidationForAllFields();
    };

    _this.runValidationForField = function (field, validationErrors) {
      var validationError = (0, _validate["default"])(_this.state.values, field.validators, _this.state.values[field.fieldId]);

      if (validationError) {
        validationErrors[field.fieldId] = validationError;
      } else {
        delete validationErrors[field.fieldId];
      }
    };

    _this.refetchOptionsList = function (key) {
      var fieldOptions = _this.state.fieldOptions[key];

      if (!fieldOptions || (0, _isEmpty["default"])(fieldOptions.url)) {
        return false;
      } // create loading promise


      var promise = _fieldOptionsHelper["default"].getOptions(fieldOptions.url, _this.state.fields.find(function (field) {
        return field.fieldId === key;
      }), _this.props.api, true, // Force refetch of the data
      _this.context.useApiGateway);

      _this.fieldOptionsResolvers[key] = {
        url: fieldOptions.url,
        promise: promise
      };
      promise.then(function (options) {
        if (_this.mounted) {
          var _fieldOptions2 = (0, _cloneDeep["default"])(_this.state.fieldOptions);

          _fieldOptions2[key].options = options;
          _this.fieldOptionsResolvers[key].promise = undefined;
          _this.props.onFieldOptionsLoaded && _this.props.onFieldOptionsLoaded(key, options);

          _this.setState({
            fieldOptions: _fieldOptions2
          });
        }
      });
    };

    _this.runValidationForAllFields = function () {
      // const validationErrors = { ...this.state.validationErrors }
      var validationErrors = {};
      var visibleFields = [];

      if (!_this.containsRestFields) {
        _this.visibleFieldIds.map(function (vFieldId) {
          var field = _this.state.fields.find(function (field) {
            return field.fieldId === vFieldId;
          });

          if (field) {
            visibleFields.push(field);
          }
        });
      } else {
        visibleFields = _this.state.fields;
      } // const visibleFields = this.state.fields.filter(x => this.visibleFieldIds.includes(x.name))


      (0, _each["default"])(visibleFields, function (field) {
        return _this.runValidationForField(field, validationErrors);
      });

      _this.setState({
        validationErrors: validationErrors
      });

      var isValid = (0, _isEmpty["default"])(validationErrors);

      if (!isValid) {
        _this.onlyUseThisRefToScrollToOnError.current && _this.onlyUseThisRefToScrollToOnError.current.scrollIntoView && _this.onlyUseThisRefToScrollToOnError.current.scrollIntoView({
          behavior: 'smooth'
        });
      }

      return isValid;
    };

    _this.submit = function () {
      return _this.submitWithValidation();
    };

    _this.submitWithValidation = function () {
      return new Promise(function (resolve, reject) {
        if (_this.runValidationForAllFields()) {
          _this.submitWithoutValidation().then(function (obj) {
            return resolve(obj);
          })["catch"](function (obj) {
            return reject(obj);
          });
        } else {
          reject(new Error('validation_error'));
        }
      });
    };

    _this.submitWithoutValidation = function () {
      var submitMustBeAPromise = null;

      if (_this.props.onSubmit) {
        if (_this.state.isControlled) {
          submitMustBeAPromise = _this.props.onSubmit();
        } else {
          submitMustBeAPromise = _this.props.onSubmit((0, _transformValues.transformValues)((0, _cloneDeep["default"])(_this.state.values)));
        }
      }

      if (submitMustBeAPromise instanceof Promise) {
        return submitMustBeAPromise;
      } else {
        return Promise.resolve();
      }
    };

    _this.onChange = function (fieldId, value) {
      if (_this.state.isControlled) {
        _this.props.onChange && _this.props.onChange(fieldId, value);
        return;
      }

      var values = (0, _cloneDeep["default"])(_this.state.values);
      values[fieldId] = value;

      _this.setState({
        values: values,
        isDirty: true
      });

      _this.props.onChange && _this.props.onChange(fieldId, value, values);
    };

    _this.onKeyDown = function (fieldId, value) {
      _this.props.onKeyDown && _this.props.onKeyDown(fieldId, value);
    };

    _this.onBlur = function (fieldId) {
      if (_this.props.validateFieldsOnBlur) {
        var field = _this.state.fields.find(function (field) {
          return field.fieldId === fieldId;
        });

        var validationErrors = _objectSpread({}, _this.state.validationErrors);

        _this.runValidationForField(field, validationErrors);

        _this.setState({
          validationErrors: validationErrors
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(fieldId);
      }
    };

    _this.hasRestFields = function () {
      _this.containsRestFields = true;
    };

    _this.registerFieldId = function (fieldId) {
      _this.visibleFieldIds.push(fieldId);

      _this.delayedRendered();
    };

    _this.unRegisteredFieldId = function (fieldId) {
      (0, _remove["default"])(_this.visibleFieldIds, function (itemId) {
        return itemId === fieldId;
      });

      _this.delayedRendered();
    };

    _this.delayedRendered = function () {
      // dont re-render evertime, lets it cool downs a little bit
      if (_this.setReRenderTimeout) {
        window.clearTimeout(_this.setReRenderTimeout);
      }

      _this.setReRenderTimeout = window.setTimeout(function () {
        _this.forceUpdate();
      }, 100);
    };

    _this.visibleFieldIds = [];
    _this.fieldOptionsResolvers = {};
    _this.state = {
      fields: [],
      values: props.defaultValues || (0, _get["default"])(props, 'schema.values') || {},
      validationErrors: {},
      fieldOptions: {},
      isDirty: false,
      schemaIsLoading: true
    };
    _this.mounted = true;
    _this.onlyUseThisRefToScrollToOnError = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(PropertyEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.loadFieldOptions();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.loadFieldOptions();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          generateFields = _this$props.generateFields,
          disableAutoFocus = _this$props.disableAutoFocus,
          dataElementLocation = _this$props.dataElementLocation,
          dataElementLabelPrefix = _this$props.dataElementLabelPrefix,
          dataElementIdPrefix = _this$props.dataElementIdPrefix;
      var PropertyEditorInternalContextValue = {
        fields: this.state.fields,
        fieldPortalValuesOnlyUseForFieldPortalsAllOtherUseCasesWillBreakTheControlledPropertyEditor: this.state.values,
        visibleFieldIds: this.visibleFieldIds,
        // *ref to this array, defined on this PropertyEditor instance
        registerFieldId: this.registerFieldId,
        hasRestFields: this.hasRestFields,
        containsRestFields: this.containsRestFields,
        unRegisterFieldId: this.unRegisteredFieldId,
        additionalFieldTypes: this.context.additionalFieldTypes,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onBlur: this.onBlur,
        dataElementLocation: dataElementLocation,
        dataElementLabelPrefix: dataElementLabelPrefix,
        dataElementIdPrefix: dataElementIdPrefix,
        schemaIsLoading: this.state.schemaIsLoading
      };
      var className = 'core-property-editor-components-property-editor';

      if (this.props.className) {
        className += ' ' + this.props.className;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onlyUseThisRefToScrollToOnError,
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_propertyEditorInternalContext["default"].Provider, {
        value: PropertyEditorInternalContextValue
      }, /*#__PURE__*/_react["default"].createElement(_form["default"], {
        onChange: this.onChange,
        onValidSubmit: this.submit
      }, generateFields ? _schemaResolver["default"].resolve(this.state.fields, this.state.values, this.context.additionalFieldTypes, this.context.skeletonLoader, disableAutoFocus) : null, children)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Set the isControlled flag, this indicates if the Property-Editor should keep track of the values
      var isControlled = props.values != null;

      var newValues = _objectSpread({}, state.values); // Set the isControlled flag, always show the values that are provided by parent


      if (isControlled) {
        newValues = props.values;
      }

      var schema = _schemaResolver["default"].validateAndAdjustSchema(props.schema, newValues, {
        FieldProps: props.FieldProps,
        submitErrors: props.submitErrors,
        validationErrors: state.validationErrors,
        variant: props.variant,
        fieldOptions: state.fieldOptions
      });

      var schemaIsLoading = state.schemaIsLoading;

      if (props.schema && state.schemaIsLoading) {
        schemaIsLoading = false;
      }

      var newState = {
        fields: schema.fields,
        isControlled: isControlled,
        values: newValues,
        schemaIsLoading: schemaIsLoading
      }; // Compare new state with old state. if its the same do not update it.

      return newState;
    }
  }]);
  return PropertyEditor;
}(_react.Component);

PropertyEditor.contextType = _propertyEditorContext["default"];
PropertyEditor.propTypes = {
  schema: _propTypes["default"].object,
  // eslint-disable-line
  onSubmit: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  submitErrors: _propTypes["default"].object,
  // eslint-disable-line
  generateFields: _propTypes["default"].bool,
  defaultValues: _propTypes["default"].object,
  values: _propTypes["default"].object,
  // eslint-disable-line
  className: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  FieldProps: _propTypes["default"].object,
  // eslint-disable-line
  variant: _propTypes["default"].oneOf(['standard', 'outlined', 'filled']),
  // eslint-disable-line
  api: _propTypes["default"].string,
  disableAutoFocus: _propTypes["default"].bool,
  dataElementLocation: _propTypes["default"].oneOf(_taggingHelper.DataElementLocationsArray).isRequired,
  dataElementLabelPrefix: _propTypes["default"].string.isRequired,
  dataElementIdPrefix: _propTypes["default"].string.isRequired,
  onFieldOptionsLoaded: _propTypes["default"].func,
  validateFieldsOnBlur: _propTypes["default"].bool.isRequired
};
PropertyEditor.defaultProps = {
  generateFields: true,
  variant: 'outlined',
  disableAutoFocus: false,
  validateFieldsOnBlur: true
};
var _default = PropertyEditor;
exports["default"] = _default;